import {gql} from "@apollo/client";

export const createMessage = gql`
    mutation createMessage($messageText: String!, $userId: Int!) {
        createMessage(messageText: $messageText, userId: $userId) {
            messageText
            messageRead
            messageId
        }
    }
`

export const DeleteMessage = gql`
    mutation deleteMessage($messages: [Int!]) {
        deleteMessage(messages: $messages)
    }
`

export const SetMessagesRead = gql`
    mutation setMessagesRead($userId: Int!) {
        setMessagesRead(userId: $userId)
    }
`